import InputField from 'components/fields/InputField';
import React, { useEffect, useState } from 'react';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';

const SchoolInformation = ({ schoolData, handleChange, setDisable }) => {
  const [errors, setErrors] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
    setTimeout(() => setShowPassword(false), 2000);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
    setTimeout(() => setShowConfirmPassword(false), 2000);
  };

  useEffect(() => {
    const newErrors = [];

    // Check if password and confirm password match
    if (schoolData.password !== schoolData.confirmPassword) {
      newErrors.push('Password and confirm password do not match.');
    }

    // Check password length
    if (schoolData.password.length < 8) {
      newErrors.push('Password must be at least 8 characters long.');
    }

    // Check password complexity
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(schoolData.password)) {
      newErrors.push(
        'Password must contain at least one uppercase letter, one lowercase letter, one number, one special character and range between 8 to 15 digits.'
      );
    }

    setErrors(newErrors);

    // Enable/disable the next button based on errors
    setDisable(newErrors.length > 0);
  }, [schoolData, setDisable]);

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      {/* Header */}
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        School Information
      </h4>
      {/* content */}
      <div className="mx-auto mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
        <InputField
          maxLength={50}
          extra="mb-3"
          label="Organization Name"
          placeholder="eg. Modern High School"
          id="name"
          type="text"
          name="name"
          onChange={handleChange}
          value={schoolData.name}
          required
        />
        <br />
        <div className="relative">
          <InputField
            maxLength={15}
            minLength={8}
            extra="mb-3"
            label="Password"
            placeholder="eg. Min 8 digit"
            id="lastname"
            type={showPassword ? 'text' : 'password'}
            name="password"
            onChange={handleChange}
            value={schoolData.password}
            required
          />
          <button
            type="button"
            className="absolute right-4 top-2/3 -translate-y-1/2 transform text-lg text-navy-700 dark:text-white"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <RiEyeLine /> : <RiEyeCloseLine />}
          </button>
        </div>
        <div className="relative">
          <InputField
            minLength={8}
            maxLength={15}
            extra="mb-3"
            label="Confirm Password"
            placeholder="eg. Min 8 digit"
            id="lastname"
            type={showConfirmPassword ? 'text' : 'password'}
            name="confirmPassword"
            onChange={handleChange}
            value={schoolData.confirmPassword}
          />
          <button
            type="button"
            className="absolute right-4 top-2/3 -translate-y-1/2 transform text-lg text-navy-700 dark:text-white"
            onClick={toggleConfirmPasswordVisibility}
          >
            {showConfirmPassword ? <RiEyeLine /> : <RiEyeCloseLine />}
          </button>
        </div>
        {/* Display errors */}
        {errors.length > 0 && (
          <div className="text-red-500">
            {errors.map((error, index) => (
              <p key={index}>{error}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SchoolInformation;
